import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        "gtmTypeSelectInput",
        "booleanValueSelectWrapper",
        "booleanValueSelectInput",
        "integerValueNumberWrapper",
        "integerValueNumberInput",
        "templateValueTextareaWrapper",
        "templateValueTextareaInput",
        "tagBelongsToWrapper",
        "tagBelongsToInput",
        "triggerBelongsToWrapper",
        "triggerBelongsToInput"
    ];

    typeSelected() {
        const selectedType = this.gtmTypeSelectInputTarget.value

        // Define which field should be visible for each type
        const visibleFieldMap = {
            "booleanValueSelect": "boolean",
            "integerValueNumber": "integer",
            "templateValueTextarea": "template",
            "tagBelongsTo": "tag_reference",
            "triggerBelongsTo": "trigger_reference"
        };

        Object.keys(visibleFieldMap).forEach((field) => {
            if (visibleFieldMap[field] == selectedType) {
                this[`${field}WrapperTarget`].classList.remove("hidden")
            } else {
                this[`${field}WrapperTarget`].classList.add("hidden")
                this[`${field}InputTarget`].value = null
            }
        })
    }
}